@if (isLoading()) {
  <app-shimmer-effect />
} @else {
  <section class="page-heading">
    <div>
      <h4>Audit Logs</h4>
      <small>Track all system activity and changes across the platform</small>
    </div>

  </section>

  <section class="data-cards">

    <div class="data-card">
      <div class="img-box today">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_63_117)">
            <path d="M10.4899 1.49856H4.49563C4.09819 1.49856 3.71702 1.65644 3.43599 1.93748C3.15495 2.21851 2.99707 2.59967 2.99707 2.99712V14.9856C2.99707 15.383 3.15495 15.7642 3.43599 16.0452C3.71702 16.3263 4.09819 16.4841 4.49563 16.4841H13.487C13.8844 16.4841 14.2656 16.3263 14.5466 16.0452C14.8277 15.7642 14.9855 15.383 14.9855 14.9856V5.99423L10.4899 1.49856Z" stroke="#1D4ED8" stroke-width="1.3487"/>
            <path d="M10.49 1.49856V5.99423H14.9857" stroke="#1D4ED8" stroke-width="1.3487"/>
            <path d="M11.9884 9.74063H5.99414" stroke="#1D4ED8" stroke-width="1.3487"/>
            <path d="M11.9884 12.7377H5.99414" stroke="#1D4ED8" stroke-width="1.3487"/>
          </g>
          <defs>
            <clipPath id="clip0_63_117">
              <rect width="17.9827" height="17.9827" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      </div>

      <div>
        <p>Today</p>
        <h4>{{ dashboardData()?.logsToday ?? 'No data' }}</h4>
      </div>
    </div>


    <div class="data-card">
      <div class="img-box creations">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_63_131)">
            <path d="M10.4899 1.49856H4.49563C4.09819 1.49856 3.71702 1.65644 3.43599 1.93748C3.15495 2.21851 2.99707 2.59967 2.99707 2.99712V14.9856C2.99707 15.383 3.15495 15.7642 3.43599 16.0452C3.71702 16.3263 4.09819 16.4841 4.49563 16.4841H13.487C13.8844 16.4841 14.2656 16.3263 14.5466 16.0452C14.8277 15.7642 14.9855 15.383 14.9855 14.9856V5.99423L10.4899 1.49856Z" stroke="#008000" stroke-width="1.3487"/>
            <path d="M10.49 1.49856V5.99423H14.9857" stroke="#008000" stroke-width="1.3487"/>
            <path d="M11.9884 9.74063H5.99414" stroke="#008000" stroke-width="1.3487"/>
            <path d="M11.9884 12.7377H5.99414" stroke="#008000" stroke-width="1.3487"/>
          </g>
          <defs>
            <clipPath id="clip0_63_131">
              <rect width="17.9827" height="17.9827" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      </div>

      <div>
        <p>Creations</p>
        <h4>{{ dashboardData()?.creations ?? 'No data' }}</h4>
      </div>
    </div>

    <div class="data-card">
      <div class="img-box today">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_63_117)">
            <path d="M10.4899 1.49856H4.49563C4.09819 1.49856 3.71702 1.65644 3.43599 1.93748C3.15495 2.21851 2.99707 2.59967 2.99707 2.99712V14.9856C2.99707 15.383 3.15495 15.7642 3.43599 16.0452C3.71702 16.3263 4.09819 16.4841 4.49563 16.4841H13.487C13.8844 16.4841 14.2656 16.3263 14.5466 16.0452C14.8277 15.7642 14.9855 15.383 14.9855 14.9856V5.99423L10.4899 1.49856Z" stroke="#1D4ED8" stroke-width="1.3487"/>
            <path d="M10.49 1.49856V5.99423H14.9857" stroke="#1D4ED8" stroke-width="1.3487"/>
            <path d="M11.9884 9.74063H5.99414" stroke="#1D4ED8" stroke-width="1.3487"/>
            <path d="M11.9884 12.7377H5.99414" stroke="#1D4ED8" stroke-width="1.3487"/>
          </g>
          <defs>
            <clipPath id="clip0_63_117">
              <rect width="17.9827" height="17.9827" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      </div>

      <div>
        <p>Updates</p>
        <h4>{{ dashboardData()?.updateLogs ?? 'No data' }}</h4>
      </div>
    </div>

    <div class="data-card">
      <div class="img-box updates">
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_63_145)">
            <path d="M10.4899 1.49856H4.49563C4.09819 1.49856 3.71702 1.65644 3.43599 1.93748C3.15495 2.21851 2.99707 2.59967 2.99707 2.99712V14.9856C2.99707 15.383 3.15495 15.7642 3.43599 16.0452C3.71702 16.3263 4.09819 16.4841 4.49563 16.4841H13.487C13.8844 16.4841 14.2656 16.3263 14.5466 16.0452C14.8277 15.7642 14.9855 15.383 14.9855 14.9856V5.99423L10.4899 1.49856Z" stroke="#B91C1C" stroke-width="1.3487"/>
            <path d="M10.49 1.49856V5.99423H14.9857" stroke="#B91C1C" stroke-width="1.3487"/>
            <path d="M11.9884 9.74063H5.99414" stroke="#B91C1C" stroke-width="1.3487"/>
            <path d="M11.9884 12.7377H5.99414" stroke="#B91C1C" stroke-width="1.3487"/>
          </g>
          <defs>
            <clipPath id="clip0_63_145">
              <rect width="17.9827" height="17.9827" fill="white"/>
            </clipPath>
          </defs>
        </svg>
      </div>

      <div>
        <p>Status Change</p>
        <h4>{{ dashboardData()?.statusChangeLogs ?? 'No data' }}</h4>
      </div>
    </div>

  </section>

  <section class="table-content">

    <section class="filters">
      <input (input)="getAuditLogs('search', search)" [(ngModel)]="search" type="search" name="search" id="search"
             placeholder="Search name, username, type...">

      <div>
        @if (loggedUserRole === 'SUPER_ADMIN' && schools() !== null) {
          <select (change)="getAuditLogs('school_id', filterSchoolId)" [(ngModel)]="filterSchoolId" name="schoolId"
                  id="schoolId">
            <option value="" hidden disabled>Select a school</option>

            @for (s of schools()?.payload; track $index) {
              <option [value]="s.id">{{ Helpers.capitalizeWords(s.school_name) }}</option>
            }

          </select>
        }

        <select (change)="getAuditLogs('action', type)" [(ngModel)]="type" name="action" id="action">
          <option value="" hidden disabled>Select a type</option>
          <option value="">All types</option>
          <option value="CREATE">Create</option>
          <option value="UPDATE">Update</option>
          <option value="STATUS_CHANGE">Status Change</option>
          <option value="LOGIN">Login</option>
          <option value="">All Types</option>
        </select>

        <!--        <select (change)="getAuditLogs('entity_type', type)" [(ngModel)]="feature" name="feature" id="feature">-->
        <!--          <option value="" hidden disabled>Select a feature</option>-->
        <!--          <option value="ACTIVE">Active</option>-->
        <!--          <option value="INACTIVE">Inactive</option>-->
        <!--          <option value="ARCHIVED">Archived</option>-->
        <!--        </select>-->
      </div>
    </section>

    <div class="table-wrapper">
    <table>
      <thead>
      <tr>
        <th>AUDIT ID</th>
        <th>USERNAME</th>
        <th>FULL NAME</th>
        <th>TYPE</th>
        <th>FEATURE</th>
        <th>DATE</th>
        <th>TIME</th>
      </tr>
      </thead>

      <tbody>
        @if (isFiltering()) {
          <td colspan="7">
            <app-loading-indicator />
          </td>
        } @else {
          @if (!audits()?.payload?.length) {
            <tr>
              <td colspan="7" class="empty">
                <app-not-found-error>
                  NO AUDIT RECORDS FOUND
                </app-not-found-error>
              </td>
            </tr>
          } @else {
            @for (u of audits()?.payload; track u.id) {
              <tr [title]="u.description">
                <td>
                  {{ u.public_id }}
                </td>

                <td>
                  &#64;{{ u.username }}
                </td>

                <td>
                  {{ ((u?.first_name ?? '') + ' ' + (u?.last_name)) }}
                </td>

                <td class="status">
                  <p [ngClass]="u.action">{{ Helpers.replaceUnderscore(u.action) }}</p>
                </td>

                <td class="entity-type">
                  <p>
                    {{ Helpers.replaceUnderscore(u.entity_type) }}
                  </p>
                </td>

                <td>
                  {{ Helpers.formatDate(u.created_at) }}
                </td>

                <td>
                  {{ Helpers.formatTime(u.created_at) }}
                </td>

              </tr>
            }
          }
        }
      </tbody>
    </table>
  </div>

    <app-pagination
      [page]="audits()?.pagination?.page ?? 0"
      [size]="audits()?.pagination?.size ?? 10"
      [totalElements]="audits()?.pagination?.totalElements ?? 0"
      [totalPages]="audits()?.pagination?.totalPages ?? 0"
      [first]="audits()?.pagination?.first ?? true"
      [last]="audits()?.pagination?.last ?? false"
      [hasNext]="audits()?.pagination?.hasNext ?? false"
      [hasPrevious]="audits()?.pagination?.hasPrevious ?? false"
      (pageChange)="loadPage($event)">
    </app-pagination>

  </section>

}
